import { parseDate } from './utils'

export default class Ticket {
	static fromJSON(json) {
		return new Ticket(
			json.id,
			json.processId,
			json.ticketType,
			json.ticketStatus,
			json.voidReason,
			json.observations
		)
			.withRequisitionId(json.requisitionId)
			.withDescription(json.description)
			.withAuthor(json.author)
			.withCreationDate(json.creationDate)
			.withUpdateUser(json.updateUser)
			.withUpdateDate(json.updateDate)
			.withResponseUser(json.responseUser)
			.withResponseDate(json.updateDate)
			.withHasParent(json.hasParent)
			.withAppointment(json.appointment)
			.withRequisition(json.requisition)
			.withTicketParent(json.parentTicket)
			.withChilds(json.childs)
	}

	constructor(id, processId, ticketType, ticketStatus, voidReason, answer) {
		this.id = id
		this.ticketType = ticketType
		this.ticketStatus = ticketStatus
		this.processId = processId
		this.voidReason = voidReason
		this.answer = answer
	}

	withRequisitionId(requisitionId) {
		this.requisitionId = requisitionId
		return this
	}

	withDescription(description) {
		this.description = description
		return this
	}

	withCreationDate(creationDate) {
		this.creationDate = creationDate ? parseDate(creationDate) : {}
		return this
	}

	withAuthor(author) {
		this.author = author
		return this
	}

	withUpdateDate(updateDate) {
		this.updateDate = updateDate ? parseDate(updateDate) : {}
		return this
	}

	withUpdateUser(updateUser) {
		this.updateUser = updateUser
		return this
	}

	withResponseDate(responseDate) {
		this.responseDate = responseDate ? parseDate(responseDate) : {}
		return this
	}

	withResponseUser(responseUser) {
		this.responseUser = responseUser
		return this
	}

	withHasParent(hasParent) {
		this.hasParent = hasParent
		return this
	}

	withAppointment(appointment) {
		this.appointment = appointment
			? { ...appointment, date: parseDate(appointment.scheduledDate) }
			: null

		return this
	}

	withRequisition(requisition) {
		this.requisition = requisition
			? { ...requisition, date: parseDate(requisition.scheduledDate) }
			: null

		return this
	}

	withTicketParent(parent) {
		this.parentTicket = parent
			? { ...parent, date: parseDate(parent.scheduledDate) }
			: null

		return this
	}

	withChilds(childs) {
		this.childs = childs ? childs.map(child => new Ticket.fromJSON(child)): []

		return this
	}
}
